<template>
  <div class="costom-scrollar" :class="style">
    <slot name="scrollbar"></slot>
  </div>
</template>

<script>
import { scrollbarStyles as scs } from '@/utils/dict';

export default {
  name: 'Scrollbar',
  props: {
    type: {
      type: String,
      default: 'bold'
    }
  },
  computed: {
    style() {
      const { type } = this;
      return scs[type];
    }
  }
};
</script>

<style lang="scss">
.costom-scrollar {
  width: 100%;
  height: 100%;
  overflow: auto;
  &.bold-sc {
    @include scrollar-style-bold;
  }
  &.thin-sc {
    @include scrollar-style-thin;
  }
  &.none-sc {
    @include scrollar-style-none;
  }
}
</style>
